<template lang="pug">
#section2
  h2.title.d-inline-block.px-3
    span.default-color Mapa de municipios con fosas en la entidad
  .pl-3
    p.my-4 A continuación, se presenta un mapa a escala municipal que detalla la distribución territorial del total de fosas clandestinas observadas por la prensa durante el periodo estudiado (2009 a julio 2020). Al seleccionar los municipios se desglosa el total de fosas que registra cada uno.
    iframe.map(src="/assets//docs/leaflet-map.html")
    p.legend.bold.text-center Figure 3.1: Total de fosas por municipio.
    p.my-4.pb-5 En el mapa se puede identificar cómo es que los municipios de las regiones Centro-Oeste, Sur-Oeste, Sur y Centro-Este son aquellos que han tenido observaciones de fosas en la entidad (municipios en amarillo), mientras que las regiones Norte y Noreste permancen sin tener registros de fosas por la prensa (municipios en blanco).
      sup
        a#anchor4.accent-color.bolder(href='#footnote4') 4

</template>

<script>
export default {
  name: "section2"
};
</script>

<style lang="scss">
#section2 {
  .map {
    width: 100%;
    height: 65vh;
  }
}
//small devices
@media (max-width: 420px) {
  #section2 {
    .map {
      width: 100%;
      height: 50vh;
    }
  }
}
</style>
